module.exports = __webpack_public_path__ + "img/img_certification_mark_02.d2c3c5f.svg";